export const DEFAULT_DEBOUNCE_DURATION = 500
export const DEFAULT_INTERACTIVE_TIMEOUT_DURATION = 10_000
export const DEADLINE_BUFFER = 250

export const INHERIT_FROM_PARENT = Symbol('inheritFromParent')
